import axios from "../axios/index.js";

const urlGetMaterialTypeList = "/api/material/get-list";
const urlCreateMaterial = "/api/material/create";
const urlUpdateMaterial = "/api/material/update/";
// const urlGetMaterialTypeSlug = "/api/material/check-slug";
const urlGetMaterialTypeDetail = "/api/material/detail/";
const urlDeleteColor = "/api/material/delete/";

export default {
    getList(params) {
        return axios.post(urlGetMaterialTypeList, params);
    },

    getDetail(id) {
        return axios.post(urlGetMaterialTypeDetail + id);
    },

    create(params, config) {
        return axios.post(urlCreateMaterial, params, config);
    },

    update(params, id, config) {
        return axios.post(urlUpdateMaterial + id, params, config);
    },

    delete(id) {
        return axios.post(urlDeleteColor + id, id);
    },

    // getSlug(params) {
    //     return axios.post(urlGetMaterialTypeSlug, params);
    // },
};
